import { render, staticRenderFns } from "./SVGGroup.vue?vue&type=template&id=6ebd4acb&"
import script from "./SVGGroup.vue?vue&type=script&lang=js&"
export * from "./SVGGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports